import React from "react";
import { USZipCodeRegexMask } from "./constants";
import PostalCodeInput from "./PostalCodeInput";

interface ZipCodeProps {
    locationType?: string;
    onChange?: (e: { target: { value: string } }) => void;
    placeholder?: string;
    value?: string | null;
    className?: string;
}

const USZipCode: React.FunctionComponent<ZipCodeProps> = (props) => (
    <PostalCodeInput mask={USZipCodeRegexMask} maskChar={"_"} {...props} type="tel" />
);

USZipCode.defaultProps = {
    placeholder: "Zip code",
};

export default USZipCode;
